<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-xxl-3 col-xl-4 col-lg-4 col-md-4 mb-4">
            <div class="card" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#connectOutlook" @click="connect('outlook')">
              <div class="card-body p-3">
                <div class="row">
                  <div class="d-flex flex-column h-100">
                    <div class="d-flex" style="align-items: center; padding-bottom: 5px;">
                      <img style="margin-right: 5px;" width="30" height="30" src="https://img.icons8.com/color/96/ms-outlook.png" alt="ms-outlook"/>
                      <h5 class="font-weight-bolder">Outlook</h5>
                    </div>
                    <p>
                      Integrate ToMate to your Outlook's workspace
                    </p>
                    <a
                      class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                      data-bs-toggle="modal" data-bs-target="#connectOutlook"
                    >
                      Connect
                      <i
                        class="fas fa-arrow-right text-sm ms-1"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-3 col-xl-4 col-lg-4 col-md-4 mb-4">
            <div class="card" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#connectGmail" @click="connect('gmail')">
                <div class="card-body p-3">
                  <div class="row">
                    <div class="d-flex flex-column h-100">
                      <div class="d-flex" style="align-items: center; padding-bottom: 5px;">
                        <img style="margin-right: 5px;" width="30" height="30" src="https://img.icons8.com/fluency/96/gmail-new.png" alt="gmail-new"/>
                        <h5 class="font-weight-bolder">Gmail</h5>
                      </div>
                      <p>
                        Integrate ToMate to your Gmail's workspace
                      </p>
                      <a
                        class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                        data-bs-toggle="modal" data-bs-target="#connectGmail"
                      >
                        Connect
                        <i
                          class="fas fa-arrow-right text-sm ms-1"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="col-xxl-3 col-xl-4 col-lg-4 col-md-4 mb-4">
            <div class="card" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#connectWhatsapp" @click="connect('whatsapp')">
                <div class="card-body p-3">
                  <div class="row">
                    <div class="d-flex flex-column h-100">
                      <div class="d-flex" style="align-items: center; padding-bottom: 5px;">
                        <img style="margin-right: 5px;" width="30" height="30" src="https://img.icons8.com/color/96/whatsapp--v1.png" alt="whatsapp--v1"/>
                        <h5 class="font-weight-bolder">WhatsApp Web</h5>
                      </div>
                      <p>
                        Integrate ToMate to your WhatsApp Web
                      </p>
                      <a
                        class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                        data-bs-toggle="modal" data-bs-target="#connectWhatsapp"
                      >
                        Connect
                        <i
                          class="fas fa-arrow-right text-sm ms-1"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="col-xxl-3 col-xl-4 col-lg-4 col-md-4 mb-4">
            <div class="card" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#connectHubspot" @click="connect('hubspot')">
                <div class="card-body p-3">
                  <div class="row">
                    <div class="d-flex flex-column h-100">
                      <div class="d-flex" style="align-items: center; padding-bottom: 5px;">
                        <img style="margin-right: 5px;" width="30" height="30" src="https://img.icons8.com/external-tal-revivo-color-tal-revivo/48/external-hubspot-a-developer-and-marketer-of-software-products-logo-color-tal-revivo.png" alt="external-hubspot-a-developer-and-marketer-of-software-products-logo-color-tal-revivo"/>
                        <h5 class="font-weight-bolder">HubSpot</h5>
                      </div>
                      <p>
                        Integrate ToMate to your HubSpot workspace
                      </p>
                      <a
                        class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                        data-bs-toggle="modal" data-bs-target="#connectHubspot"
                      >
                        Connect
                        <i
                          class="fas fa-arrow-right text-sm ms-1"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <!--<div class="col-xxl-3 col-xl-4 col-lg-4 col-md-4 mb-4">
            <div class="card" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#connectSalesforce" @click="connect('salesforce')">
                <div class="card-body p-3">
                  <div class="row">
                    <div class="d-flex flex-column h-100">
                      <div class="d-flex" style="align-items: center; padding-bottom: 5px;">
                        <img style="margin-right: 5px;" width="30" height="30" src="https://img.icons8.com/color/48/salesforce.png" alt="salesforce"/>
                        <h5 class="font-weight-bolder">Salesforce Lightning</h5>
                      </div>
                      <p>
                        Integrate ToMate to Salesforce Lightning
                      </p>
                      <a
                        class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                        data-bs-toggle="modal" data-bs-target="#connectSalesforce"
                      >
                        Connect
                        <i
                          class="fas fa-arrow-right text-sm ms-1"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
            </div>
          </div>-->
          <div class="col-xxl-3 col-xl-4 col-lg-4 col-md-4 mb-4">
            <div class="card" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#connectIntercom" @click="connect('intercom')">
                <div class="card-body p-3">
                  <div class="row">
                    <div class="d-flex flex-column h-100">
                      <div class="d-flex" style="align-items: center; padding-bottom: 5px;">
                        <img style="margin-right: 5px;" width="30" height="30" src="https://img.icons8.com/external-tal-revivo-bold-tal-revivo/48/external-intercom-an-american-software-company-that-produces-a-messaging-platform-logo-bold-tal-revivo.png" alt="external-intercom-an-american-software-company-that-produces-a-messaging-platform-logo-bold-tal-revivo"/>
                        <h5 class="font-weight-bolder">Intercom</h5>
                      </div>
                      <p>
                        Integrate ToMate to Intercom workspace
                      </p>
                      <a
                        class="text-body text-sm font-weight-bold mb-0 icon-move-right mt-auto"
                        data-bs-toggle="modal" data-bs-target="#connectIntercom"
                      >
                        Connect
                        <i
                          class="fas fa-arrow-right text-sm ms-1"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Outlook connection-->
    <div class="modal fade" data-bs-backdrop="static" id="connectOutlook" tabindex="-1" aria-labelledby="connectOutlookLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="connectOutlookLabel">Connect ToMate to Outlook</h5>
            
          </div>
          <div>
              <TimelineList
                class="h-100"
                title="Follow these simple steps"
              > 
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <i class="ni ni-cloud-download-95 text-info"></i>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      1. Download extension
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      First you have to download the extension from the store, you can access it from the link below, 
                      if you do not have an Outlook account, you will have to create one.
                    </p>
                    <a class="text-sm" target="_blank" href="https://appsource.microsoft.com/en/product/Office365/WA200005605">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Download ToMate's extension for Outlook
                      </SoftButton>
                    </a>
                    
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="https://img.icons8.com/color/96/ms-outlook.png" alt="ms-outlook"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      2. Browse to your Outlook inbox
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      Once you downloaded the extension you must go to your Outlook Inbox.
                    </p>
                    <a class="text-sm" target="_blank" href="https://outlook.live.com/">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Open Outlook
                      </SoftButton>
                    </a>
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="../assets/img/favicon.png" alt="ms-outlook"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      3. Use ToMate
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      If you have completed the previous steps, you can start using ToMate in your Outlook workspace. 
                      By clicking on any email you want to answer, you will find the ToMate's logo located in the upper-right corner of the section.
                    </p>
                    <img style="border-radius: 25px; margin-top: 15px;" height="50" src="../assets/img/outlook-tomate.png" />
                  </div>
                </div>
              </TimelineList>
          </div>
          <div class="modal-footer">
            <SoftButton data-bs-dismiss="modal">Done</SoftButton>
          </div>
        </div>
      </div>
    </div>
    <!-- Gmail connection-->
    <div class="modal fade" data-bs-backdrop="static" id="connectGmail" tabindex="-1" aria-labelledby="connectGmailLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="connectGmailLabel">Connect ToMate to Gmail</h5>
            
          </div>
          <div>
              <TimelineList
                class="h-100"
                title="Follow these simple steps"
              > 
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <i class="ni ni-cloud-download-95 text-info"></i>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      1. Download extension
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      First you have to download the extension from the Chrome Store, you can access it from the link below.
                    </p>
                    <a class="text-sm" target="_blank" href="https://chrome.google.com/webstore/detail/tomate-by-human-trends/bkafhnojcfphpcffdngljcjfhhmoflfn">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Download ToMate's extension for Chrome
                      </SoftButton>
                    </a>
                    
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="https://img.icons8.com/fluency/96/gmail-new.png" alt="gmail-new"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      2. Browse to your Gmail inbox
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      Once you downloaded the extension you must go to your Gmail inbox, if you do not have an account, you will have to create one.
                    </p>
                    <a class="text-sm" target="_blank" href="https://mail.google.com/">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Open Gmail
                      </SoftButton>
                    </a>
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="../assets/img/favicon.png" alt="tomate-logo"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      3. Use ToMate
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      If you have completed the previous steps, you can start using ToMate in your Gmail workspace. 
                      By clicking on any email you want to answer, you will encounter the email body or thread of emails. At the bottom of this section there will be
                      three button as shown below.
                    </p>
                    <img style="border-radius: 25px; margin: 15px 0;" height="50" src="../assets/img/gmail-buttons.png" />
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      After clicking on any of these buttons, the chat section will appear. You will find the ToMate's logo located next to the "Send Email"
                      button in the lower-left corner of the section.
                    </p>
                    <img style="border-radius: 25px; margin-top: 15px;" height="50" src="../assets/img/gmail-tomate.png" />
                  </div>
                </div>
              </TimelineList>
          </div>
          <div class="modal-footer">
            <SoftButton data-bs-dismiss="modal">Done</SoftButton>
          </div>
        </div>
      </div>
    </div>
    <!-- Whatsapp connection-->
    <div class="modal fade" data-bs-backdrop="static" id="connectWhatsapp" tabindex="-1" aria-labelledby="connectWhatsappLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="connectWhatsappLabel">Connect ToMate to WhatsApp Web</h5>
            
          </div>
          <div>
              <TimelineList
                class="h-100"
                title="Follow these simple steps"
              > 
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <i class="ni ni-cloud-download-95 text-info"></i>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      1. Download extension
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      First you have to download the extension from the Chrome Store, you can access it from the link below.
                    </p>
                    <a class="text-sm" target="_blank" href="https://chrome.google.com/webstore/detail/tomate-by-human-trends/bkafhnojcfphpcffdngljcjfhhmoflfn">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Download ToMate's extension for Chrome
                      </SoftButton>
                    </a>
                    
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="https://img.icons8.com/color/96/whatsapp--v1.png" alt="whatsapp--v1"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      2. Browse to WhatsApp Web
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      Once you downloaded the extension you must go to your WhatsApp Web. If you do not have a device linked to your browser,
                      you can link it by following this official tutorial <a target="_blank" href="https://faq.whatsapp.com/1317564962315842/?locale=en_US&cms_platform=web">How to link a device</a>
                    </p>
                    <a class="text-sm" target="_blank" href="https://web.whatsapp.com/">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Open WhatsApp Web
                      </SoftButton>
                    </a>
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="../assets/img/favicon.png" alt="tomate-logo"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      3. Use ToMate
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      If you have completed the previous steps, you can start using ToMate in your WhatsApp Web. 
                      By clicking on any chat you want to answer, you will find the ToMate's logo located next to 
                      "audio" button, in the lower-right corner of the chat section.
                    </p>
                    <img style="border-radius: 25px; margin-top: 15px;" height="50" src="../assets/img/whatsapp-tomate.png" />
                  </div>
                </div>
              </TimelineList>
          </div>
          <div class="modal-footer">
            <SoftButton data-bs-dismiss="modal">Done</SoftButton>
          </div>
        </div>
      </div>
    </div>
    <!-- Salesforce connection-->
    <div class="modal fade" data-bs-backdrop="static" id="connectSalesforce" tabindex="-1" aria-labelledby="connectSalesforceLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="connectWhatsappLabel">Connect ToMate to Salesforce Lightning</h5>
            
          </div>
          <div>
              <TimelineList
                class="h-100"
                title="Follow these simple steps"
              > 
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <i class="ni ni-cloud-download-95 text-info"></i>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      1. Download extension
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      First you have to download the extension from the Chrome Store, you can access it from the link below.
                    </p>
                    <a class="text-sm" target="_blank" href="https://chrome.google.com/webstore/detail/tomate-by-human-trends/bkafhnojcfphpcffdngljcjfhhmoflfn">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Download ToMate's extension for Chrome
                      </SoftButton>
                    </a>
                    
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="https://img.icons8.com/color/48/salesforce.png" alt="salesforce"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      2. Browse to Salesforce Lightning
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      Once you downloaded the extension you must go to your Salesforce workspace. If you do not have an account,
                      you can sign up in the following link <a target="_blank" href="https://www.salesforce.com/form/signup/freetrial-elf-v2/">Sign up for free</a>
                    </p>
                    <a class="text-sm" target="_blank" href="https://login.salesforce.com/">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Open Salesforce Lightning
                      </SoftButton>
                    </a>
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="../assets/img/favicon.png" alt="tomate-logo"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      3. Use ToMate
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      If you have completed the previous steps, you can start using ToMate in Salesforce Lightning. 
                      First, open the menu, under Salesforce logo, in the upper-left corner of your screen, and select "Service Console"
                    </p>
                    <img style="border-radius: 25px; margin: 15px 15px;" height="150" src="../assets/img/step1_salesforce.png" />
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      Secondly, click on any of the cases listed on the left side of your screen. Then, click on "compose", on the lower-right corner of your screen.
                    </p>
                    <img style="border-radius: 25px; margin: 15px 15px;" height="175" src="../assets/img/step2_salesforce.png" />
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      Finally, you will see ToMate's button attached to the tool bar located on the lower-left corner of the email composer.
                    </p>
                    <img style="border-radius: 25px; margin: 15px 15px;" height="50" src="../assets/img/step3_salesforce.png" />
                  </div>
                </div>
              </TimelineList>
          </div>
          <div class="modal-footer">
            <SoftButton data-bs-dismiss="modal">Done</SoftButton>
          </div>
        </div>
      </div>
    </div>
    <!-- Intercom connection-->
    <div class="modal fade" data-bs-backdrop="static" id="connectIntercom" tabindex="-1" aria-labelledby="connectIntercomLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="connectWhatsappLabel">Connect ToMate to Intercom</h5>
            
          </div>
          <div>
              <TimelineList
                class="h-100"
                title="Follow these simple steps"
              > 
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <i class="ni ni-cloud-download-95 text-info"></i>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      1. Download extension
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      First you have to download the extension from the Chrome Store, you can access it from the link below.
                    </p>
                    <a class="text-sm" target="_blank" href="https://chrome.google.com/webstore/detail/tomate-by-human-trends/bkafhnojcfphpcffdngljcjfhhmoflfn">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Download ToMate's extension for Chrome
                      </SoftButton>
                    </a>
                    
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="https://img.icons8.com/external-tal-revivo-bold-tal-revivo/48/external-intercom-an-american-software-company-that-produces-a-messaging-platform-logo-bold-tal-revivo.png" alt="external-intercom-an-american-software-company-that-produces-a-messaging-platform-logo-bold-tal-revivo"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      2. Browse to Intercom
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      Once you downloaded the extension you must go to your Intercom workspace. If you do not have an account,
                      you will be asked to create one.
                    </p>
                    <a class="text-sm" target="_blank" href="https://app.intercom.com/">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Open Intercom
                      </SoftButton>
                    </a>
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="../assets/img/favicon.png" alt="tomate-logo"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      3. Use ToMate
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      If you have completed the previous steps, you can start using ToMate in Intercom. 
                      First, on the top of the left menu, click the inbox logo.
                    </p>
                    <img style="border-radius: 25px; margin: 15px 15px;" height="150" src="../assets/img/step1_intercom.png" />
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      Then select any of the conversations you want to answer to, you will find ToMate's logo located on the left side of the message input.
                    </p>
                    <img style="border-radius: 25px; margin: 15px 15px;" height="150" src="../assets/img/step2_intercom.png" />
                  </div>
                </div>
              </TimelineList>
          </div>
          <div class="modal-footer">
            <SoftButton data-bs-dismiss="modal">Done</SoftButton>
          </div>
        </div>
      </div>
    </div>
    <!-- Hubspot connection-->
    <div class="modal fade" data-bs-backdrop="static" id="connectHubspot" tabindex="-1" aria-labelledby="connectHubspotLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="connectWhatsappLabel">Connect ToMate to HubSpot</h5>
            
          </div>
          <div>
              <TimelineList
                class="h-100"
                title="Follow these simple steps"
              > 
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <i class="ni ni-cloud-download-95 text-info"></i>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      1. Download extension
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      First you have to download the extension from the Chrome Store, you can access it from the link below.
                    </p>
                    <a class="text-sm" target="_blank" href="https://chrome.google.com/webstore/detail/tomate-by-human-trends/bkafhnojcfphpcffdngljcjfhhmoflfn">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Download ToMate's extension for Chrome
                      </SoftButton>
                    </a>
                    
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="https://img.icons8.com/external-tal-revivo-color-tal-revivo/48/external-hubspot-a-developer-and-marketer-of-software-products-logo-color-tal-revivo.png" alt="external-hubspot-a-developer-and-marketer-of-software-products-logo-color-tal-revivo"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      2. Browse to HubSpot
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      Once you downloaded the extension you must go to your HubSpot workspace. If you do not have an account,
                      you will be asked to create one.
                    </p>
                    <a class="text-sm" target="_blank" href="https://app.hubspot.com/login">
                      <SoftButton style="font-size: 10px;" class="mt-3 mb-2" size="sm" variant="outline">
                        Open HubSpot
                      </SoftButton>
                    </a>
                  </div>
                </div>
                <div class="mb-3 timeline-block" >
                  <span class="timeline-step">
                    <img width="16" height="16" src="../assets/img/favicon.png" alt="tomate-logo"/>
                  </span>
                  <div class="timeline-content">
                    <h6
                      class="mb-0 text-sm font-weight-bold"
                    >
                      3. Use ToMate
                    </h6>
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      If you have completed the previous steps, you can start using ToMate in HubSpot. 
                      First, click the conversations' dropdown and select "inbox" on the upper-right corner of your screen, as shown in the following image.
                    </p>
                    <img style="border-radius: 25px; margin: 15px 15px;" height="150" src="../assets/img/step1_hubspot.png" />
                    <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                      Then select any of the conversations you want to answer to, you will find ToMate's logo located on the left side of the message input.
                    </p>
                    <img style="border-radius: 25px; margin: 15px 15px;" height="150" src="../assets/img/step2_hubspot.png" />
                  </div>
                </div>
              </TimelineList>
          </div>
          <div class="modal-footer">
            <SoftButton data-bs-dismiss="modal">Done</SoftButton>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Did not upload data -->
    <div class="modal fade" data-bs-backdrop="static" id="didNotUploadData" tabindex="-1" aria-labelledby="didNotUploadDataLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="didNotUploadData">Train your AI before connecting</h5>
          </div>
          <div class="card-body text-center">
            <img
              style="padding: 10px;"
              class="w-60 position-relative z-index-2 pt-4"
              src="../assets/img/Server-pana.png"
              alt="questions"
            />
            <p >Hey there! Before we jump into connecting with communication channels, remember to train your AI buddy with documents,
            websites, past emails, or FAQs in the database section. It'll help make our interactions smoother and smarter! 😊</p>

            <SoftButton @click="goToDB()" class="mt-3 mb-2">
              Go to AI Database
            </SoftButton>
          </div>
          <div class="modal-footer">
            <SoftButton style="display: none" id="closePopup" data-bs-dismiss="modal">Done</SoftButton>
          </div>
        </div>
      </div>
    </div>

    <button style="display: none" id="botonAbrirPopup" data-bs-toggle="modal" data-bs-target="#didNotUploadData"></button>
  </div>
</template>

<script>
import HTFetch from "../llamadas/HTFetch"
import SoftButton from "../components/SoftButton.vue"
import TimelineList from "../views/components/TimelineList.vue";
import router from '../router/index'

export default {
  name: "connections",

  components: {
    SoftButton,
    TimelineList
  },

  data() { 
    return {
      llamada: new HTFetch(),
      responseMessage: "",
      showResponseMessage: false,
    }
  },

  mounted() {
    //checkeo si creo data
    this.llamada.dataGenerated(this.dataGeneratedRsp.bind(this))

    this.llamada.userInfo(this.userInfoRsp.bind(this))
  },

  methods: {
    dataGeneratedRsp(rsp) {
      if (rsp.data.data_len <= 0) {
        var myModalEl = document.getElementById('botonAbrirPopup');
        myModalEl.click();
      }
    },

    goToDB() {
      var myModalEl = document.getElementById('closePopup');
      myModalEl.click();

      router.push({name: "Database"})
    },

    userInfoRsp(rsp) {
      let collecciones = []
      for (let i = 0; i < Object.keys(rsp.data.collections).length; i++) {
        collecciones.push({
          "name": Object.keys(rsp.data.collections)[i],
          "token": Object.values(rsp.data.collections)[i]
        })
      }

      localStorage.collections = JSON.stringify(collecciones)

      this.collections = JSON.parse(localStorage.collections)

      localStorage.userId = rsp.data.token
      
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "connections",
          user_id: localStorage.userId
        });
      }
    },

    connect(plataforma) {
     if (plataforma === 'outlook') {
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "outlook",
          user_id: localStorage.userId
        });
      }
     } else if (plataforma === 'gmail') {
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "gmail",
          user_id: localStorage.userId
        });
      }
     } else if (plataforma === 'whatsapp') {
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "whatsapp",
          user_id: localStorage.userId
        });
      }
     } else if (plataforma === 'salesforce') {
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "salesforce",
          user_id: localStorage.userId
        });
      }
     } else if (plataforma === 'intercom') {
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "intercom",
          user_id: localStorage.userId
        });
      }
     } else if (plataforma === 'hubspot') {
      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "hubspot",
          user_id: localStorage.userId
        });
      }
     }
    } 
  }
};
</script>

<style scoped>

.font-weight-bolder {
  font-size: 14px;
  margin: 0;
}

</style>